export enum JobTypeEndpoints {
  FetchJobTypes = '/job-types',
}
